<template>
  <div
    class="b2b-details-box position-relative"
    :class="open_accor == true ? 'mobile-sidebar-card' : ''"
  >
    <div class="b2b-details-box-header" @click="developpBlock">
      <div class="d-flex justify-content-between">
        <div>
          <h2 class="font-bold mb-0">Consommation du compte</h2>
        </div>
        <div
          v-if="open_accor == true"
          @click="developpBlock"
          class="
            chevron-parent
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <i
            @click="developpBlock"
            class="mdi mdi-chevron-right"
            style="font-size: 24px !important"
          ></i>
        </div>
        <div
          v-if="open_accor == false && checkScreen === 'mobile'"
          @click="developpBlock"
          class="
            chevron-parent
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <i
            @click="developpBlock"
            class="mdi mdi-chevron-down"
            style="font-size: 24px !important"
          ></i>
        </div>
      </div>
    </div>
    <div class="mt-3" v-show="open_accor == false">
      <Skeleton :number="3" v-if="on_loading == true" />
      <div
        v-else
        :class="{
          'b2b-overlay-content-mini': minify_details,
        }"
      >
        <EmptyState
          :message="'Aucune consommation disponible pour ce compte'"
          v-if="consommation_account.length == 0 || head.length == 0"
        />
        <div v-else>
          <table class="table table-striped font-14">
            <tbody>
              <tr v-for="(head, index) in head" :key="index">
                <th scope="row">{{ head }}</th>
                <td class="text-right" style="width: 120px">
                  {{ consommation_account[index] }}
                </td>
              </tr>
            </tbody>
          </table>
          <div
            v-if="minify_details == true"
            class="
              b2b-overlay
              w-100
              d-flex
              align-items-center
              justify-content-center
            "
          >
            <div>
              <b-button variant="primary" @click="minify_details = false"
                >Tout afficher</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from "@/components/business/skeleton";
import EmptyState from "@/components/business/emptyState";
export default {
  name: "conso-account",
  components: {
    Skeleton,
    EmptyState,
  },
  props: {
    head: {
      type: Array,
      default: () => [],
    },
    consommation_account: {
      type: Array,
      default: () => [],
    },
    on_loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      minify_details: true,
      open_accor: false,
    };
  },
  created: async function () {
    if (this.checkScreen === "mobile") {
      this.open_accor = true;
      this.minify_details = false;
    }
  },
  computed: {
    checkScreen() {
      if (window.screen.availWidth >= 625) {
        return "laptop";
      } else {
        return "mobile";
      }
    },
  },
  methods: {
    developpBlock() {
      if (this.checkScreen == "mobile") {
        this.open_accor = !this.open_accor;
      }
    },
  },
};
</script>
<style scoped>
.table th,
.table td {
  font-weight: 400 !important;
}
.b2b-overlay-content-mini {
  height: 200px;
  overflow: hidden;
}
.b2b-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 40% !important;
  background-image: linear-gradient(
    180deg,
    rgb(255 255 255 / 9%) -6%,
    rgba(255, 255, 255, 0.9) 13%
  ) !important;
  border-radius: 12px !important;
}
</style>